import { render } from "./ControllerType.vue?vue&type=template&id=0930a590&scoped=true"
import script from "./ControllerType.vue?vue&type=script&lang=js"
export * from "./ControllerType.vue?vue&type=script&lang=js"

import "./ControllerType.vue?vue&type=style&index=0&id=0930a590&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0930a590"]])

export default __exports__